import request from "../../Request";
import authStore from "../../../Stores/AuthStore/AuthStore";
import {rThen} from "../../requestThen";

export let activationAccount = async () => {

    return request.get(`/api/User/activation/email/send/${authStore.decodeJwt.userId}`, true).then(r => {
        return rThen(r);
    })
}